{
  "common": {
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Eliminar",
    "done": "Listo",
    "edit": "Editar",
    "search": "Buscar",
    "loading": "Cargando…",
    "yes": "Sí",
    "no": "No",
    "settings": "Ajustes",
    "back": "Atrás",
    "close": "Cerrar",
    "open": "Abrir",
    "copy": "Copiar",
    "restore": "Restaurar",
    "untitled": "Sin título",
    "create": "Crear",
    "revoke": "Revocar",
    "never": "Nunca",
    "tryAgain": "Reintentar",
    "reload": "Recargar",
    "update": "Actualizar",
    "insert": "Insertar",
    "loadingShort": "Cargando",
    "unknown": "Desconocido",
    "sampleSentence": "El veloz murciélago hindú"
  },
  "sidebar": {
    "views": "Vistas",
    "tags": "Etiquetas",
    "edit": "Editar",
    "done": "Listo",
    "account": "Cuenta",
    "newNote": "Nueva nota",
    "editTag": "Editar etiqueta",
    "tagOptions": "Opciones de etiqueta",
    "reorder": "Reordenar {{label}}",
    "showView": "Mostrar {{label}}",
    "hideView": "Ocultar {{label}}",
    "editViews": "Editar vistas",
    "doneEditingViews": "Terminar de editar",
    "samplePeep": "Caliu es…",
    "sampleQuiet": "Un lugar tranquilo donde tus ideas pueden vivir y respirar."
  },
  "views": {
    "all": "Todas las notas",
    "today": "Hoy",
    "todo": "Tareas",
    "pinned": "Fijadas",
    "untagged": "Sin etiquetas",
    "thisWeek": "Esta semana",
    "shared": "Compartidas por mí",
    "sharedWithMe": "Compartidas conmigo",
    "attachments": "Adjuntos",
    "trash": "Papelera",
    "archive": "Archivadas"
  },
  "noteList": {
    "empty": "Aún no hay notas",
    "emptySubtitle": "Crea la primera para empezar.",
    "untitled": "Sin título",
    "selectNote": "Selecciona una nota",
    "selectNoteHint": "Elige una nota de la lista o crea una nueva.",
    "selectRestoreOrDelete": "Selecciona una nota para restaurarla o eliminarla definitivamente",
    "selectSharedToView": "Selecciona una nota compartida para verla",
    "searchPlaceholder": "Buscar notas…",
    "selectNotes": "Seleccionar notas",
    "openSidebar": "Abrir barra lateral",
    "cancelSelection": "Cancelar selección",
    "clearSelection": "Limpiar selección",
    "emptyTrash": "Vaciar papelera",
    "newNote": "Nueva nota",
    "noteCount_one": "{{count}} nota",
    "noteCount_other": "{{count}} notas",
    "sortBy": "Ordenar por",
    "preview": "Vista previa",
    "modificationDate": "Fecha de modificación",
    "creationDate": "Fecha de creación",
    "title": "Título",
    "manual": "Manual",
    "newestOnTop": "Más recientes arriba",
    "small": "Pequeña",
    "medium": "Mediana",
    "large": "Grande",
    "empty_pinned": "Nada fijado aún",
    "empty_pinned_subtitle": "Fija una nota para encontrarla rápido aquí.",
    "empty_today": "Nada editado hoy",
    "empty_today_subtitle": "Las notas que edites hoy aparecerán aquí.",
    "empty_todo": "Aún no hay tareas",
    "empty_todo_subtitle": "Las notas con tareas pendientes aparecerán aquí.",
    "empty_untagged": "Todo está etiquetado",
    "empty_untagged_subtitle": "Las notas sin etiquetas aparecerán aquí.",
    "empty_thisWeek": "Nada esta semana",
    "empty_thisWeek_subtitle": "Las notas editadas en los últimos 7 días aparecerán aquí.",
    "empty_shared": "No hay notas compartidas",
    "empty_shared_subtitle": "Las notas que compartas aparecerán aquí.",
    "empty_attachments": "Aún no hay adjuntos",
    "empty_attachments_subtitle": "Las notas con imágenes o archivos aparecerán aquí.",
    "justNow": "Justo ahora",
    "minutesAgo": "hace {{count}} min",
    "today": "Hoy",
    "yesterday": "Ayer",
    "deletedOn": "Eliminada el {{date}}",
    "newNoteShortcut": "Nueva nota ({{shortcut}})",
    "noContent": "Sin contenido",
    "selectUnarchiveOrDelete": "Selecciona una nota para desarchivarla o eliminarla",
    "view": "Visualización",
    "density": "Densidad",
    "exportAll": "Exportar todo"
  },
  "editor": {
    "attachmentTooLarge": "Este archivo es demasiado grande para adjuntarlo. El límite es 100 MB.",
    "placeholder": "Empieza a escribir…",
    "noMatchingCommands": "No hay comandos coincidentes",
    "newNote": "nueva nota",
    "noResults": "Sin resultados",
    "foldSection": "Plegar sección",
    "unfoldSection": "Desplegar sección",
    "dragSection": "Mover sección",
    "presenceLabel": "También aquí: {{names}}"
  },
  "noteActions": {
    "pin": "Fijar",
    "unpin": "Desfijar",
    "pinToTop": "Fijar arriba",
    "makeReadOnly": "Hacer solo lectura",
    "makeEditable": "Hacer editable",
    "readOnlyNote": "Nota de solo lectura",
    "shareNote": "Compartir nota",
    "share": "Compartir",
    "publiclyShared": "Compartida públicamente",
    "privateNote": "Nota privada",
    "linkCreated": "Enlace creado",
    "linkCreatedAndCopied": "Enlace creado y copiado",
    "linkRevoked": "Enlace de compartir revocado",
    "failedToCreateShareLink": "No se pudo crear el enlace de compartir",
    "failedToRevokeShareLink": "No se pudo revocar el enlace de compartir",
    "thisNoteIsPrivate": "Esta nota es privada.",
    "createPublicLink": "Crear enlace público",
    "creatingLink": "Creando enlace…",
    "revokeLink": "Revocar enlace",
    "revokingLink": "Revocando…",
    "copyLink": "Copiar enlace",
    "copyNoteId": "Copiar ID de nota",
    "noteIdCopied": "ID de nota copiado",
    "exportAs": "Exportar como",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Texto plano",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "Error al exportar",
    "viewHistory": "Ver historial",
    "duplicate": "Duplicar",
    "duplicateFailed": "No se pudo duplicar la nota",
    "select": "Seleccionar",
    "delete": "Eliminar",
    "moveToTrash": "Mover a la papelera",
    "archive": "Archivar",
    "unarchive": "Desarchivar",
    "tags": "Etiquetas",
    "addTag": "Añadir etiqueta",
    "noTagsYet": "Aún no hay etiquetas",
    "addTagFailed": "No se pudo añadir la etiqueta",
    "removeTagFailed": "No se pudo quitar la etiqueta"
  },
  "userMenu": {
    "theme": "Tema",
    "typography": "Tipografía",
    "language": "Idioma",
    "apiKeys": "Claves API",
    "devices": "Dispositivos",
    "connectedApps": "Apps conectadas",
    "help": "Ayuda",
    "logOut": "Cerrar sesión",
    "defaultUserName": "Usuario de Caliu",
    "editName": "Editar nombre",
    "nameLabel": "Nombre",
    "namePlaceholder": "Tu nombre",
    "upgradeToPro": "Mejora a Caliu Pro",
    "replayOnboarding": "Repetir la introducción",
    "logOutTitle": "¿Cerrar sesión?",
    "logOutBody": "Tus notas se quedan en este dispositivo y puedes seguir leyéndolas y escribiéndolas. Vuelve a iniciar sesión para sincronizar.",
    "logOutPending_one": "{{count}} cambio aún no se ha sincronizado. Se queda en este dispositivo hasta que vuelvas a iniciar sesión.",
    "logOutPending_other": "{{count}} cambios aún no se han sincronizado. Se quedan en este dispositivo hasta que vuelvas a iniciar sesión.",
    "logOutKeep": "Cerrar sesión",
    "logOutAndRemove": "Cerrar sesión y eliminar notas"
  },
  "help": {
    "title": "Centro de ayuda",
    "searchPlaceholder": "Buscar artículos de ayuda",
    "noResults": "Ningún artículo coincide con tu búsqueda.",
    "offline": "La ayuda no está disponible sin conexión. Se cargará la próxima vez que estés conectado."
  },
  "fonts": {
    "uiFont": "Fuente de la interfaz",
    "body": "Cuerpo",
    "headings": "Títulos",
    "code": "Código",
    "sans": "Sans",
    "serif": "Serif",
    "mono": "Mono",
    "editor": "Editor",
    "ui": "Interfaz",
    "reset": "Restablecer"
  },
  "themes": {
    "light": "Claro",
    "dark": "Oscuro",
    "system": "Sistema"
  },
  "languages": {
    "systemHint": "Detectado de tu dispositivo",
    "names": {
      "en": "Inglés",
      "es": "Español",
      "ca": "Catalán",
      "fr": "Francés",
      "de": "Alemán",
      "it": "Italiano",
      "pt": "Portugués",
      "nl": "Neerlandés",
      "ja": "Japonés",
      "zh-CN": "Chino (simplificado)",
      "ko": "Coreano",
      "zh-TW": "Chino (tradicional)",
      "ru": "Ruso"
    }
  },
  "bulkActions": {
    "pinSelected": "Fijar seleccionadas",
    "unpinSelected": "Desfijar seleccionadas",
    "pin": "Fijar",
    "addTag": "Añadir etiqueta",
    "filterTags": "Filtrar etiquetas…",
    "noTagsFound": "No se encontraron etiquetas",
    "exportSelected": "Exportar seleccionadas",
    "restoreSelected": "Restaurar seleccionadas",
    "deletePermanently": "Eliminar definitivamente",
    "moveToTrash": "Mover a la papelera",
    "archiveSelected": "Archivar selección",
    "unarchiveSelected": "Desarchivar selección",
    "exportingTitle": "Exportando tus notas",
    "exportingBody": "Esto puede tardar un momento. Mantén esta pestaña abierta hasta que termine.",
    "exportingProgress": "{{done}} de {{total}}"
  },
  "commandPalette": {
    "placeholder": "Buscar notas, etiquetas, comandos…",
    "noResults": "Sin resultados para «{{query}}»",
    "currentNote": "Nota actual",
    "navigation": "Navegación",
    "notes": "Notas",
    "tags": "Etiquetas",
    "newNote": "Nueva nota",
    "allNotes": "Todas las notas",
    "todaysNotes": "Notas de hoy",
    "todo": "Tareas",
    "pinnedNotes": "Notas fijadas",
    "trash": "Papelera",
    "importNotes": "Importar notas",
    "changeTheme": "Cambiar tema",
    "keyboardShortcuts": "Atajos de teclado",
    "pinNote": "Fijar nota",
    "unpinNote": "Desfijar nota",
    "restoreNote": "Restaurar nota",
    "copyShareLink": "Copiar enlace para compartir",
    "makePrivate": "Hacer privada",
    "toggleFullscreen": "Pantalla completa",
    "noteInfo": "Información de la nota",
    "moveToTrash": "Mover a la papelera",
    "archiveNote": "Archivar nota",
    "unarchiveNote": "Desarchivar nota",
    "archive": "Archivadas"
  },
  "noteHistory": {
    "title": "Historial de la nota",
    "requiresConnection": "El historial de notas requiere conexión.",
    "reconnect": "Reconéctate a Internet e inténtalo de nuevo.",
    "noHistory": "Aún no hay historial para esta nota.",
    "windowMerged": "Las ediciones dentro de una ventana de 5 minutos se combinan en una sola entrada.",
    "selectVersion": "Selecciona una versión para previsualizar",
    "encrypted": "Captura cifrada",
    "encryptedHint": "Esta versión se guardó con cifrado de extremo a extremo. Abre la nota para ver el contenido actual.",
    "restoreVersion": "¿Restaurar esta versión?",
    "restoreVersionHint": "Esto reemplazará el contenido actual de la nota con la versión del {{date}}.",
    "current": "Actual",
    "created": "Creada",
    "trashed": "Eliminada",
    "restored": "Restaurada",
    "edited": "Editada"
  },
  "apiKeys": {
    "title": "Claves API",
    "empty": "Aún no hay claves API.",
    "emptyHint": "Crea una para empezar a usar la API.",
    "created": "Creada el {{date}}",
    "lastUsed": "Último uso: {{date}}",
    "revokeKey": "Revocar clave",
    "viewApiDocs": "Ver documentación de la API",
    "newApiKey": "Nueva clave API",
    "apiKeyCreated": "Clave API creada",
    "createApiKey": "Crear clave API",
    "copyHint": "Copia esta clave ahora. No podrás volver a verla.",
    "copyToClipboard": "Copiar al portapapeles",
    "keyName": "Nombre de la clave",
    "keyNamePlaceholder": "p. ej., Mi script, Integración Zapier",
    "createKey": "Crear clave",
    "revokeKeyTitle": "Revocar clave API",
    "revokeKeyHint": "Esto revocará permanentemente esta clave API. Cualquier aplicación que la use perderá el acceso de inmediato.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "Apps conectadas",
    "empty": "Aún no hay apps conectadas.",
    "emptyHint": "Conecta Claude, ChatGPT u otro asistente de IA para usar tus notas desde el chat. La sección Caliu con IA de Ayuda explica cómo.",
    "connected": "Conectada el {{date}}",
    "lastUsed": "Último uso: {{date}}",
    "revoke": "Revocar",
    "revokeTitle": "Revocar conexión",
    "revokeHint": "Esto revocará el acceso de <strong>{{name}}</strong> a tu cuenta de Caliu y eliminará las credenciales que utilizaba. Perderá el acceso de inmediato.",
    "thisApp": "esta app",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Escritura",
    "metadata": "Metadatos",
    "words": "Palabras",
    "characters": "Caracteres",
    "paragraphs": "Párrafos",
    "readTime": "Tiempo de lectura",
    "minutes": "{{count}} min",
    "tags": "Etiquetas",
    "outgoingLinks": "Enlaces salientes",
    "backlinks": "Retroenlaces",
    "created": "Creada",
    "modified": "Modificada",
    "noteStatistics": "Estadísticas de la nota",
    "identifier": "Identificador"
  },
  "inspector": {
    "tabInfo": "Info",
    "tabOutline": "Esquema",
    "tabHistory": "Historial",
    "dates": "Fechas",
    "noHeadings": "No hay encabezados en esta nota",
    "noBacklinks": "Ninguna nota enlaza aquí",
    "noOutgoing": "Esta nota no enlaza a nada",
    "noAttachments": "No hay adjuntos en esta nota",
    "historyOffline": "El historial de versiones necesita conexión",
    "historyLoadMore": "Cargar más"
  },
  "devices": {
    "title": "Dispositivos",
    "offline": "Estás sin conexión.",
    "offlineHint": "Conéctate a Internet para ver tus dispositivos.",
    "noSessions": "No se encontraron sesiones activas.",
    "thisDevice": "Este dispositivo",
    "lastUsed": "Último uso: {{date}}",
    "created": "Creado: {{date}}",
    "signOutCurrent": "Cerrar sesión en este dispositivo",
    "signOut": "Cerrar sesión",
    "confirmCurrentTitle": "¿Cerrar sesión en este dispositivo?",
    "confirmRevokeTitle": "¿Revocar dispositivo?",
    "confirmCurrentBody": "Se cerrará tu sesión de Caliu en este navegador y las notas se eliminarán de este dispositivo. Vuelve a iniciar sesión cuando quieras y regresarán desde tu cuenta.",
    "confirmRevokeBody": "El dispositivo cerrará sesión de inmediato. Los cambios sin sincronizar permanecerán allí hasta que vuelvas a iniciar sesión.",
    "revoke": "Revocar"
  },
  "errorScreen": {
    "title": "Algo salió mal",
    "defaultMessage": "Se produjo un error inesperado. Intenta recargar la página."
  },
  "importModal": {
    "title": "Importar notas",
    "dropToImport": "Suelta para importar",
    "dropOrClick": "Suelta archivos o haz clic para buscar",
    "removeFile": "Quitar archivo",
    "keepNote": "Para Google Keep, exporta un ZIP de Takeout y sube ese archivo directamente.",
    "importedCount_one": "Se importó <strong>{{count}}</strong> nota",
    "importedCount_other": "Se importaron <strong>{{count}}</strong> notas",
    "fromSource": " desde {{source}}",
    "importing": "Importando…",
    "importN": "Importar {{count}} archivos",
    "importBtn": "Importar"
  },
  "share": {
    "shareNote": "Compartir nota",
    "publiclySharedAria": "La nota se comparte públicamente",
    "copyLink": "Copiar enlace",
    "revokingLink": "Revocando…",
    "revokeLink": "Revocar enlace",
    "creatingLink": "Creando enlace…",
    "createPublicLink": "Crear enlace público",
    "shareThisNotePublicly": "Compartir esta nota públicamente",
    "thisNoteIsPrivate": "Esta nota es privada.",
    "publiclyShared": "Compartida públicamente",
    "privateNote": "Nota privada"
  },
  "shortcuts": {
    "searchPlaceholder": "Buscar atajos…",
    "pressNew": "Pulsa el nuevo atajo…",
    "resetToDefault": "Restablecer al valor predeterminado",
    "noMatches": "No hay atajos que coincidan con «<strong>{{query}}</strong>»",
    "navigate": "navegar",
    "edit": "editar",
    "closeAction": "cerrar",
    "resetAll": "Restablecer todo"
  },
  "tagEditor": {
    "icon": "Icono",
    "color": "Color",
    "searchIcons": "Buscar iconos",
    "noIcons": "Ningún icono coincide",
    "categories": {
      "essentials": "Esenciales",
      "work": "Trabajo y tecnología",
      "ideas": "Ideas y creatividad",
      "life": "Personas y hogar",
      "travel": "Viajes y naturaleza",
      "fun": "Comida, salud y ocio"
    }
  },
  "tagActions": {
    "pin": "Fijar etiqueta",
    "unpin": "Desfijar etiqueta",
    "rename": "Renombrar…",
    "renameTitle": "Renombrar etiqueta",
    "renameConfirm": "Renombrar",
    "renameHint": "La etiqueta se actualiza en todas las notas que la usan, incluidas las archivadas y las de la papelera.",
    "renamed": "Etiqueta renombrada",
    "nameInUse": "Ese nombre ya está en uso",
    "invalidName": "Los nombres de etiqueta solo pueden usar letras, números, espacios, guiones y guiones bajos",
    "pinFailed": "No se pudo actualizar la etiqueta",
    "renameFailed": "No se pudo renombrar la etiqueta",
    "editAppearance": "Editar apariencia"
  },
  "auth": {
    "appName": "Caliu",
    "or": "o",
    "email": "Correo electrónico",
    "emailPlaceholder": "tu@ejemplo.com",
    "password": "Contraseña",
    "passwordPlaceholder": "Contraseña",
    "name": "Nombre",
    "namePlaceholder": "Tu nombre",
    "confirmPassword": "Confirmar contraseña",
    "newPassword": "Nueva contraseña",
    "confirmNewPassword": "Confirmar nueva contraseña",
    "signInSubtitle": "Inicia sesión en tu cuenta",
    "createAccountSubtitle": "Crea tu cuenta",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "signingIn": "Iniciando sesión…",
    "signIn": "Iniciar sesión",
    "noAccount": "¿No tienes cuenta?",
    "signUp": "Crear cuenta",
    "haveAccount": "¿Ya tienes cuenta?",
    "creatingAccount": "Creando cuenta…",
    "createAccount": "Crear cuenta",
    "googleSignUpAria": "Registrarse con Google",
    "signupClosedTitle": "El registro está cerrado por ahora",
    "signupClosedBody": "Caliu está en beta privada. Únete a la lista de espera en caliuapp.com para conseguir acceso anticipado.",
    "joinWaitlist": "Únete a la lista de espera",
    "forgotTitle": "Restablecer contraseña",
    "forgotSubtitle": "Introduce tu correo y te enviaremos un enlace para restablecerla.",
    "sendResetLink": "Enviar enlace de restablecimiento",
    "sending": "Enviando…",
    "checkYourEmail": "Revisa tu correo",
    "resetLinkSentPrefix": "Si ",
    "resetLinkSentSuffix": " tiene una cuenta, te hemos enviado un enlace para restablecer la contraseña. Caduca en 1 hora.",
    "backToSignIn": "Volver al inicio de sesión",
    "verifySentPrefix": "Hemos enviado un enlace de verificación a ",
    "verifySentSuffix": ". Haz clic en él para activar tu cuenta.",
    "linkExpires10m": "El enlace caduca en 10 minutos.",
    "resending": "Reenviando…",
    "resendEmail": "Reenviar correo",
    "wrongEmail": "¿Correo equivocado?",
    "goBack": "Volver",
    "invalidResetLinkTitle": "Enlace de restablecimiento no válido",
    "invalidResetLinkBody": "Este enlace no es válido o ha caducado.",
    "requestNewLink": "Solicitar un enlace nuevo",
    "setNewPasswordTitle": "Establecer nueva contraseña",
    "setNewPasswordHint": "Elige una contraseña segura.",
    "updatingPassword": "Actualizando…",
    "updatePassword": "Actualizar contraseña",
    "localNotesTitle": "Tienes notas en este dispositivo",
    "localNotesBody_one": "Escribiste {{count}} nota aquí antes de iniciar sesión. ¿Qué hacemos con ella?",
    "localNotesBody_other": "Escribiste {{count}} notas aquí antes de iniciar sesión. ¿Qué hacemos con ellas?",
    "localNotesDelete": "Eliminarlas",
    "localNotesMerge": "Añadirlas a mi cuenta",
    "backToMyNotes": "Volver a mis notas",
    "errorGoogleAuthFailed": "No se pudo iniciar sesión con Google. Inténtalo de nuevo.",
    "errorInvalidToken": "Enlace de verificación no válido. Regístrate de nuevo.",
    "errorEmailTaken": "Este correo ya está en uso. Inicia sesión.",
    "signInInstead": "Inicia sesión en esa cuenta",
    "errorIdentityTaken": "Esa identidad ya pertenece a otra cuenta de Caliu. Inicia sesión con ella.",
    "parkedNotesTitle": "Notas de otra cuenta",
    "parkedNotesBody_one": "Inicia sesión en {{email}} para conservar sus notas en este dispositivo. Otra cuenta borrará la única nota que hay aquí, incluido lo escrito después.",
    "parkedNotesBody_other": "Inicia sesión en {{email}} para conservar sus notas en este dispositivo. Otra cuenta borrará las {{count}} notas que hay aquí, incluido lo escrito después.",
    "parkedNotesBodyNoEmail_one": "Inicia sesión en la cuenta de la que cerraste sesión para conservar sus notas en este dispositivo. Otra cuenta borrará la única nota que hay aquí, incluido lo escrito después.",
    "parkedNotesBodyNoEmail_other": "Inicia sesión en la cuenta de la que cerraste sesión para conservar sus notas en este dispositivo. Otra cuenta borrará las {{count}} notas que hay aquí, incluido lo escrito después.",
    "parkedNotesContinue": "Continuar"
  },
  "connectors": {
    "wantsAccess": "quiere acceder a Caliu",
    "couldntLoad": "No se pudo cargar la solicitud",
    "authorize": "Autorizar",
    "keepHappeningHint": "Si esto sigue ocurriendo, elimina el conector de tu cliente MCP y vuelve a añadirlo.",
    "backToCaliu": "Volver a Caliu",
    "askingPermissionPrefix": "solicita permiso para leer y modificar tus notas y etiquetas a través del servidor MCP de Caliu.",
    "signedInAs": "Sesión iniciada como {{name}}.",
    "permissions": "Permisos",
    "deny": "Denegar",
    "allow": "Permitir"
  },
  "editorTypography": {
    "fontSize": "Tamaño de fuente",
    "lineHeight": "Altura de línea",
    "paragraphSpacing": "Espacio entre párrafos"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Mayús"
  },
  "floatingMenu": {
    "undo": "Deshacer",
    "redo": "Rehacer",
    "taskList": "Lista de tareas",
    "bulletList": "Lista con viñetas",
    "orderedList": "Lista numerada",
    "blockQuote": "Cita en bloque",
    "separator": "Separador",
    "insertTag": "Insertar etiqueta",
    "highlight": "Resaltar",
    "math": "Fórmula",
    "removeHighlight": "Quitar resaltado",
    "inlineCode": "Código en línea",
    "codeBlock": "Bloque de código",
    "insertTable": "Insertar tabla",
    "insertImage": "Insertar imagen",
    "hideStyleBar": "Ocultar barra de estilos",
    "attachFile": "Adjuntar archivo",
    "photoLibrary": "Fototeca",
    "camera": "Cámara",
    "fromFile": "Desde archivo"
  },
  "imageDialog": {
    "title": "Insertar imagen",
    "tabUpload": "Archivo",
    "tabUrl": "URL",
    "urlLabel": "URL de la imagen",
    "urlPlaceholder": "https://ejemplo.com/imagen.jpg",
    "altLabel": "Texto alternativo",
    "altPlaceholder": "Describe la imagen…",
    "previewAlt": "vista previa",
    "changeImage": "Cambiar imagen",
    "dropToInsert": "Suelta para insertar",
    "dropOrClick": "Suelta una imagen o haz clic para buscar",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Insertar imagen"
  },
  "linkDialog": {
    "editTitle": "Editar enlace",
    "insertTitle": "Insertar enlace",
    "textLabel": "Texto",
    "textPlaceholder": "Texto del enlace",
    "urlPlaceholder": "https://ejemplo.com",
    "removeLink": "Quitar enlace",
    "openLink": "Abrir enlace",
    "editLink": "Editar enlace"
  },
  "noteEditor": {
    "notFound": "No se encontró la nota.",
    "inTrashBanner": "Esta nota está en la papelera. Restáurala para editarla.",
    "restore": "Restaurar",
    "noContent": "Esta nota no tiene contenido."
  },
  "noteHeader": {
    "noteInfo": "Información de la nota"
  },
  "table": {
    "deleteRow": "Eliminar fila",
    "deleteTable": "Eliminar tabla",
    "addRow": "Añadir fila",
    "addRowAbove": "Añadir fila encima",
    "addColumn": "Añadir columna",
    "addColumnBefore": "Añadir columna antes",
    "moveRowUp": "Mover fila arriba",
    "moveRowDown": "Mover fila abajo",
    "moveColumnLeft": "Mover columna a la izquierda",
    "moveColumnRight": "Mover columna a la derecha",
    "deleteColumn": "Eliminar columna",
    "actions": "Acciones de tabla"
  },
  "syncIndicator": {
    "synced": "Sincronizado",
    "pending_one": "{{count}} cambio pendiente",
    "pending_other": "{{count}} cambios pendientes",
    "offline": "Sin conexión",
    "offlinePending_one": "Sin conexión · {{count}} pendiente",
    "offlinePending_other": "Sin conexión · {{count}} pendientes",
    "syncing": "Sincronizando...",
    "conflict_one": "{{count}} conflicto",
    "conflict_other": "{{count}} conflictos",
    "error": "Error de sincronización",
    "syncedTooltip": "Todos los cambios guardados",
    "pendingTooltip_one": "{{count}} cambio esperando a sincronizar",
    "pendingTooltip_other": "{{count}} cambios esperando a sincronizar",
    "offlineTooltip": "Sin conexión: los cambios se sincronizarán al reconectar",
    "offlinePendingTooltip_one": "Sin conexión: {{count}} cambio se sincronizará al reconectar",
    "offlinePendingTooltip_other": "Sin conexión: {{count}} cambios se sincronizarán al reconectar",
    "syncingTooltip": "Sincronizando...",
    "syncingPendingTooltip_one": "Sincronizando {{count}} cambio pendiente...",
    "syncingPendingTooltip_other": "Sincronizando {{count}} cambios pendientes...",
    "conflictTooltip_one": "{{count}} nota tiene cambios en conflicto. Haz clic para resolver.",
    "conflictTooltip_other": "{{count}} notas tienen cambios en conflicto. Haz clic para resolver.",
    "errorTooltip": "Error al sincronizar. Se reintentará automáticamente.",
    "conflictsTitle": "Resolver conflictos",
    "local": "En este dispositivo",
    "localTooltip": "Solo en este dispositivo. Inicia sesión para sincronizar."
  },
  "image": {
    "download": "Descargar imagen",
    "replace": "Reemplazar imagen",
    "remove": "Quitar imagen"
  },
  "sharePage": {
    "goToCaliu": "Ir a Caliu",
    "noteNotFoundTitle": "Nota no encontrada",
    "somethingWentWrong": "Algo salió mal",
    "lastUpdated": "Última actualización: {{date}}",
    "tagline": "Una app de notas para quienes piensan",
    "subtagline": "Escribe en markdown. Sincroniza en todas partes. Piensa con claridad.",
    "startWriting": "Empezar a escribir",
    "signIn": "Iniciar sesión",
    "openInCaliu": "Abrir en Caliu",
    "adding": "Añadiendo…",
    "addToSharedList": "Añadir a mi lista compartida",
    "notFoundSubtitle": "Este enlace puede haber caducado o haber sido revocado.",
    "errorSubtitle": "No se pudo cargar esta nota. Inténtalo de nuevo."
  },
  "sharedView": {
    "loading": "Cargando nota compartida…",
    "sharedWithYou": "Compartida contigo",
    "viewRaw": "Ver Markdown en bruto",
    "viewRendered": "Ver nota renderizada",
    "copyMarkdown": "Copiar Markdown",
    "markdownCopied": "Markdown copiado",
    "copyFailed": "No se pudo copiar",
    "notLoadedYet": "Esta nota aún no se ha cargado",
    "linkCopied": "Enlace copiado",
    "actions": "Acciones de la nota"
  },
  "sharedWithMe": {
    "title": "Compartidas conmigo",
    "removeFromList": "Quitar de la lista",
    "empty": "Aún no hay notas compartidas",
    "emptyHint": "Abre un enlace compartido de Caliu de un amigo para añadirlo aquí. Las notas compartidas se sincronizan en todos tus dispositivos."
  },
  "trashView": {
    "empty": "La papelera está vacía",
    "emptyHint": "Las notas eliminadas aparecerán aquí",
    "retention": "Las notas de la papelera se eliminan definitivamente después de 30 días",
    "trash": "Papelera"
  },
  "fileAttachment": {
    "download": "Descargar archivo",
    "remove": "Eliminar archivo"
  },
  "archiveView": {
    "archive": "Archivadas",
    "empty": "No hay notas archivadas",
    "emptyHint": "Las notas archivadas aparecerán aquí",
    "archivedOn": "Archivada el {{date}}"
  },
  "pro": {
    "subtitle": "Caliu, sin límites.",
    "features": [
      "Notas ilimitadas",
      "Historial de versiones de notas",
      "Exporta a PDF, HTML, RTF, ePub + en lote",
      "Todos los temas, fuentes e iconos de app",
      "Apoya el desarrollo de Caliu"
    ],
    "perMonth": "{{price}} al mes",
    "perWeek": "{{price}} a la semana",
    "oneTime": "{{price}} pago único",
    "perYear": "{{price}} al año",
    "or": "o",
    "signInToSubscribe": "Inicia sesión para suscribirte",
    "accountRequired": "Caliu Pro está vinculado a tu cuenta, así que se desbloquea en todos tus dispositivos.",
    "plansUnavailable": "No hemos podido cargar los planes. Comprueba tu conexión y vuelve a intentarlo.",
    "yearly": "Anual",
    "monthly": "Mensual",
    "continue": "Continuar",
    "bestValue": "Mejor valor",
    "autoRenew": "{{amount}}. Se renueva automáticamente hasta que canceles. Cancela cuando quieras.",
    "freeTrial": "Gratis durante {{count}} días",
    "billedSubtitle": "Gratis durante {{count}} días, luego {{amount}}. Cancela cuando quieras.",
    "startTrial": "Empezar prueba gratis",
    "upgradeSubtitle": "Historial de versiones, todos los temas y fuentes, exportación y mucho más.",
    "upgradeNow": "Mejora ahora",
    "thanks": "¡Gracias por apoyar a Caliu!",
    "renewsOn": "Se renueva el {{date}}",
    "endsOn": "Termina el {{date}}",
    "lifetime": "Acceso de por vida",
    "lifetimePlan": "De por vida",
    "oneTimeNoRenewal": "Pago único",
    "launchPrice": "Precio de lanzamiento. Más adelante subirá a {{price}}.",
    "buy": "Comprar",
    "oneTimeDisclosure": "{{amount}}. Pago único, sin renovación.",
    "thanksMessage": "Tu apoyo mantiene Caliu independiente y privado.",
    "manageSubscription": "Gestionar suscripción",
    "contactUs": "¿Dudas? Escríbenos",
    "grandfatheredNote": "Como impulsor inicial, Caliu Pro es tuyo para siempre. No hay nada que renovar.",
    "webFootnote": "La exportación a PDF aún no está disponible en la web.",
    "active": "Activa"
  },
  "find": {
    "placeholder": "Buscar en la nota",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "Sin resultados",
    "next": "Coincidencia siguiente",
    "previous": "Coincidencia anterior",
    "close": "Cerrar"
  },
  "conflicts": {
    "description": "Esta nota se editó en otro dispositivo. Conserva una versión.",
    "yours": "Tu versión",
    "theirs": "Su versión",
    "step": "{{current}} de {{total}}",
    "keepYours": "Conservar la tuya",
    "keepTheirs": "Conservar la suya",
    "serverError": "No se pudo cargar la otra versión.",
    "done": "Todos los conflictos resueltos.",
    "previous": "Conflicto anterior",
    "next": "Conflicto siguiente",
    "copyOf": "Copia de {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Te damos la bienvenida a Caliu",
    "welcomeSubtitle": "Un lugar tranquilo donde tus ideas pueden vivir y respirar.",
    "getStarted": "Empezar",
    "magicTitle": "Mira cómo tus palabras toman forma",
    "magicSubtitle": "Tú escribes texto plano. Caliu lo convierte en estructura: tareas, resaltados y etiquetas que se ordenan solas.",
    "magicLearnMore": "Aprende los fundamentos de Markdown",
    "replay": "Repetir",
    "demoTitle": "Verano junto al mar",
    "demoBody": "Planear una **semana tranquila** en un pueblo pequeño.",
    "demoTask": "Reservar la casita",
    "demoHighlight": "Nadar ==antes== del desayuno",
    "demoTags": "#verano #planes",
    "intentTitle": "¿Qué traerás aquí?",
    "intentSubtitle": "Elige algunos. Tu primera nota y tus etiquetas te estarán esperando, ya tuyas.",
    "themeTitle": "Elige tu luz",
    "themeSubtitle": "Temas para acompañar el tono de tu escritura.",
    "proTitle": "Empieza con todo",
    "proSubtitle": "Empieza con todo desde el primer día. Pruébalo gratis y quédatelo solo si se gana su sitio.",
    "proTrust": "Sin anuncios. Sin trucos. Cancela cuando quieras.",
    "tryProFree": "Prueba Pro gratis",
    "continueFree": "Continuar con el plan gratuito",
    "allSetTitle": "Todo listo",
    "allSetSubtitle": "Bienvenido a Caliu. Hazlo tuyo.",
    "startWriting": "Empezar a escribir",
    "firstNoteTitle": "Donde todo empieza",
    "firstNoteBody": "Esta es mi primera nota. Vive en este dispositivo, funciona sin conexión y me sigue a todas partes.",
    "firstNoteTask": "Apuntar una idea que valga la pena guardar",
    "next": "Siguiente",
    "skip": "Omitir",
    "back": "Atrás",
    "intents": {
      "journal": "Diario",
      "ideas": "Ideas",
      "work": "Trabajo",
      "study": "Estudios",
      "reading": "Lectura",
      "plans": "Planes"
    },
    "signInCta": "Inicia sesión o regístrate",
    "continueWithoutAccount": "Continuar sin cuenta",
    "backupTitle": "Dónde viven tus notas",
    "backupSubtitle": "Empiezan en este dispositivo. Con una cuenta se sincronizan, así una copia segura llega a todos tus dispositivos.",
    "syncOffTitle": "La sincronización está desactivada",
    "syncOffBody": "Inicia sesión para sincronizar tus notas en todos tus dispositivos.",
    "backupSignedIn": "Tus notas se sincronizan de forma segura mientras escribes.",
    "backupStageDevice": "Este dispositivo",
    "backupStageSafe": "Sincronizadas",
    "backupStageEverywhere": "Todos tus dispositivos",
    "freeNotes": "{{limit}} notas gratis, sin cuenta, para siempre. Pro las hace ilimitadas."
  },
  "backup": {
    "evictionNotice": "De momento las notas viven solo en este navegador. Los navegadores pueden borrar los datos del sitio si falta espacio.",
    "dismiss": "Descartar",
    "signIn": "Iniciar sesión"
  },
  "gate": {
    "share": "Inicia sesión para compartir notas.",
    "history": "Inicia sesión para guardar el historial de versiones.",
    "import": "Inicia sesión para importar notas."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "Código LaTeX"
  },
  "noteLimit": {
    "banner": "{{count}} de {{limit}} notas",
    "paywallTitle": "Has llegado a las {{limit}} notas gratuitas",
    "paywallBody": "Editar, buscar y sincronizar siguen funcionando. Envía una nota a la papelera para liberar un hueco, o pásate a ilimitado con Caliu Pro: mensual, anual o con una compra única de por vida.",
    "importCapped": "Solo se han importado {{count}} de {{total}} archivos: el plan gratuito permite {{limit}} notas."
  },
  "appUpdate": {
    "available": "Hay una nueva versión de Caliu disponible."
  },
  "settings": {
    "title": "Ajustes",
    "account": "Cuenta",
    "writing": "Escritura",
    "keyboardShortcuts": "Atajos de teclado",
    "editor": "Editor",
    "yourNotes": "Tus notas",
    "about": "Información",
    "noAccount": "Sin cuenta",
    "sendFeedback": "Enviar comentarios",
    "signInOrCreate": "Inicia sesión o regístrate",
    "notesComeWithYou": "Las notas de este dispositivo van contigo.",
    "notSyncing": "Sin sincronizar",
    "signInToSync": "Inicia sesión para sincronizar tus notas.",
    "sync": "Sincronización",
    "security": "Seguridad",
    "communications": "Comunicaciones",
    "newsletter": "Boletín de Caliu",
    "newsletterFooter": "Un correo breve de vez en cuando sobre las nuevas versiones y lo que llega a Caliu.",
    "newsletterError": "No se pudo actualizar el boletín. Inténtalo de nuevo.",
    "appearance": "Apariencia",
    "themes": "Temas",
    "sizing": "Tamaño",
    "systemDefault": "Predeterminado del sistema",
    "separateThemes": "Temas distintos para claro y oscuro",
    "maxWidth": "Ancho máximo",
    "maxWidthHint": "Centra el texto en una columna legible en pantallas anchas",
    "markdownReturn": "Retorno estilo Markdown",
    "markdownReturnHint": "Retorno inserta un salto de línea. Pulsa Retorno dos veces para un párrafo nuevo",
    "newNoteStart": "Las notas nuevas empiezan con",
    "newNoteStartH1": "Encabezado 1",
    "newNoteStartH2": "Encabezado 2",
    "newNoteStartH3": "Encabezado 3",
    "newNoteStartH4": "Encabezado 4",
    "newNoteStartDate": "Fecha",
    "newNoteStartDateIso": "Fecha (ISO 8601)",
    "newNoteStartDateTime": "Fecha y hora",
    "newNoteStartDateTimeIso": "Fecha y hora (ISO 8601)",
    "newNoteStartEmpty": "Vacía",
    "newNoteStartHint": "Se aplica a las notas que creas en la app.",
    "collapsibleSections": "Secciones plegables",
    "collapsibleSectionsHint": "Permite plegar un encabezado y su contenido tras una flecha",
    "experimental": "Experimental",
    "general": "General"
  },
  "toolbar": {
    "toggleSidebar": "Mostrar u ocultar la barra lateral",
    "toggleInspector": "Mostrar u ocultar el inspector",
    "searchNotes": "Buscar notas",
    "newNote": "Nueva nota",
    "findInNote": "Buscar en la nota",
    "showToolbar": "Mostrar barra de herramientas",
    "hideToolbar": "Ocultar barra de herramientas",
    "moreNoteActions": "Más acciones para la nota",
    "undo": "Deshacer",
    "redo": "Rehacer",
    "zenMode": "Modo Zen",
    "sourceMode": "Modo fuente",
    "richEditor": "Editor enriquecido",
    "sortBy": "Ordenar por",
    "bold": "Negrita",
    "italic": "Cursiva",
    "heading": "Encabezado",
    "list": "Lista",
    "link": "Enlace",
    "insert": "Insertar",
    "more": "Más",
    "strikethrough": "Tachado",
    "table": "Tabla",
    "horizontalRule": "Regla horizontal",
    "codeBlock": "Bloque de código",
    "inlineCode": "Código en línea",
    "blockQuote": "Cita",
    "math": "Fórmula",
    "highlight": "Resaltado",
    "bulletList": "Lista con viñetas",
    "orderedList": "Lista numerada",
    "photoLibrary": "Fototeca",
    "camera": "Cámara",
    "files": "Archivos",
    "yellow": "Amarillo",
    "green": "Verde",
    "blue": "Azul",
    "pink": "Rosa",
    "purple": "Morado",
    "heading1": "Encabezado 1",
    "heading2": "Encabezado 2",
    "heading3": "Encabezado 3",
    "heading4": "Encabezado 4",
    "heading5": "Encabezado 5",
    "heading6": "Encabezado 6",
    "removeHighlight": "Quitar resaltado"
  },
  "whatsNew": {
    "title": "Novedades",
    "tagIconsTitle": "Iconos dibujados para Caliu",
    "tagIconsBody": "Todos los iconos de la app son nuevos y están hechos para Caliu. Dale a cada etiqueta su propio icono y búscalos en tu idioma.",
    "newNoteStartTitle": "Empieza tus notas a tu manera",
    "newNoteStartBody": "Una nota nueva puede empezar con un encabezado, la fecha de hoy, la fecha y la hora, o en blanco. Elígelo en Ajustes, en Editor.",
    "typographyTitle": "Tipografía, al punto exacto",
    "typographyBody": "Elige el tamaño exacto del texto, la altura de línea y el espacio entre párrafos de tus notas, en Ajustes, en Tipografía.",
    "typographySample": "Cada nota sigue el tamaño, la altura de línea y el espaciado que elijas, punto por punto.",
    "sampleMorningPages": "Páginas matutinas",
    "newsletterTitle": "Llega el boletín de Caliu",
    "newsletterBody": "A partir de ahora, un correo breve te cuenta las novedades de cada versión, en tu idioma. Actívalo si te apetece. Puedes cambiarlo cuando quieras en Ajustes."
  },
  "sharing": {
    "inviteByEmail": "Invitar por correo",
    "invite": "Invitar",
    "roleOwner": "Propietario",
    "roleEditor": "Puede editar",
    "roleViewer": "Puede ver",
    "generalAccess": "Acceso general",
    "shareWithLink": "Compartir con un enlace",
    "accessRestricted": "Solo las personas invitadas",
    "accessView": "Cualquiera con el enlace puede ver",
    "accessEdit": "Cualquiera con el enlace puede editar",
    "remove": "Quitar",
    "leave": "Salir",
    "leaveNote": "Salir de la nota",
    "leaveConfirmTitle": "¿Salir de esta nota?",
    "leaveConfirmBody": "Desaparecerá de tus listas en todos tus dispositivos. El propietario puede volver a invitarte.",
    "leaveSelectedTitle": "¿Salir de las notas compartidas?",
    "leaveSelectedBody_one": "Saldrás de {{count}} nota compartida contigo. Tus propias notas irán a la papelera.",
    "leaveSelectedBody_other": "Saldrás de {{count}} notas compartidas contigo. Tus propias notas irán a la papelera.",
    "sharedBy": "Compartida por {{name}}",
    "sharedList": "Compartidas",
    "viewOnly": "Solo lectura",
    "accessNowEditor": "Ahora puedes editar esta nota.",
    "accessNowViewer": "Ahora solo puedes ver esta nota.",
    "accessRemoved": "Ya no tienes acceso a esta nota.",
    "unsentSavedAsCopy": "Tus cambios sin enviar se guardaron en una copia.",
    "privateNote": "Nota privada",
    "memberLimit": "Una nota se puede compartir con un máximo de 50 personas.",
    "rateLimit": "Demasiadas invitaciones. Inténtalo más tarde.",
    "inviteFailed": "No se pudieron enviar las invitaciones. Inténtalo de nuevo.",
    "invalidEmail": "Introduce una dirección de correo válida.",
    "onlineOnly": "Conéctate a internet para gestionar el uso compartido.",
    "you": "Tú",
    "ownerOnly": "Solo el propietario puede cambiar quién tiene acceso.",
    "unavailable": "El uso compartido no está disponible ahora. Inténtalo más tarde.",
    "updateFailed": "No se pudo actualizar el uso compartido. Inténtalo de nuevo.",
    "inviteInvalid": "Esta invitación ya no es válida.",
    "copyLink": "Copiar enlace",
    "invited": "Invitado",
    "copied": "Copiado",
    "accessRestrictedHint": "Solo las personas que invites pueden abrirla.",
    "onlyYouHint": "Solo tú puedes abrirla.",
    "accessViewHint": "Cualquiera con el enlace puede leerla, sin necesidad de cuenta.",
    "accessEditHint": "Cualquiera con el enlace puede editarla.",
    "roleBelowLink": "Cualquiera con el enlace puede editar, así que las personas que invites también pueden editar.",
    "inviteAs": "Invitar como",
    "revokeInvite": "Revocar invitación",
    "statusPeople_one": "{{count}} persona",
    "statusPeople_other": "{{count}} personas",
    "publicLink": "Enlace público",
    "statusFrom": "De {{name}}",
    "removeConfirmTitle": "¿Quitar a {{name}}?",
    "removeConfirmBody": "Ya no tendrá acceso a esta nota.",
    "revokeConfirmTitle": "¿Revocar la invitación a {{name}}?",
    "revokeConfirmBody": "El enlace de la invitación dejará de funcionar.",
    "peopleWithAccess": "Personas con acceso",
    "addPeoplePlaceholder": "Añadir personas por correo",
    "invitePro": "Invitar a personas forma parte de Caliu Pro.",
    "inviteKeepsAccess": "Las personas invitadas mantienen el acceso si desactivas el enlace.",
    "youSuffix": "(tú)"
  },
  "noAccess": {
    "title": "No tienes acceso a esta nota",
    "linkBody": "Su propietario no la ha compartido contigo. Pídele que te invite o que active su enlace.",
    "signedOutBody": "Inicia sesión con la cuenta con la que se compartió.",
    "inviteTitle": "Esta invitación ya no es válida",
    "inviteBody": "Pide una nueva a la persona que te invitó.",
    "removedTitle": "Ya no tienes acceso a esta nota",
    "removedBody": "Su propietario te ha quitado.",
    "removedCopyBody": "Su propietario te ha quitado. Tus cambios sin enviar se han guardado como una copia en tus notas.",
    "backToNotes": "Volver a las notas",
    "signIn": "Iniciar sesión"
  }
}
